import { atom } from "jotai";

import { ErrorApiAtom } from "@/states/error/types";

export const errorApiAtom = atom<ErrorApiAtom>({
  error: undefined,
});
